/**
 * A simple progress bar component that uses <span> tags
 * and accepts Tailwind CSS classes.
 * @param {object} props
 * @param {number} props.value - The percentage value to fill (0-100).
 * @param {string} [props.colorClass] - The Tailwind CSS class for the fill color (e.g., 'bg-red-500').
 */
const ProgressBar = ({ value, colorClass = 'bg-blue-500' }) => {
  return (
    // bg-background-gray but increase brightness slightly
    <span className="block h-2 w-full bg-gray-200 dark:bg-background-gray-muted rounded mt-1.5 overflow-hidden">
      <span
        className={`block h-full rounded transition-all duration-300 ${colorClass}`}
        style={{ width: `${value}%` }}
      ></span>
    </span>
  );
};

export default ProgressBar;